import type { MaybeRef } from 'vue';

export const onboardingKey = 'onboarding';

export const getUserByIdKey = (userId: MaybeRef<string>) => {
  return [onboardingKey, 'get-user-by-id', userId];
};
